<template>
  <component :is="linkComponent" v-bind="linkAttr">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    to: {
      default: undefined,
      type: [String, Object],
      required: false,
    },
    href: {
      default: undefined,
      type: String,
      required: false,
    },
    linkProps: {
      default: () => ({}),
      type: Object,
      required: false,
    },
  },
  computed: {
    linkComponent() {
      return this.to !== undefined ? 'nuxt-link' : 'a'
    },
    linkAttr() {
      return this.to !== undefined
        ? { to: this.to, ...this.linkProps }
        : { href: this.href, ...this.linkProps }
    },
  },
}
</script>

<style></style>
